import { Spin } from "antd";
import React from "react";

const CircularProgress = ({ className, title }) => (
   <div className={`loader ${className}`}>
      <Spin size="large" />
      {title && <div className="gx-mt-1">{title}</div>}
   </div>
);
export default CircularProgress;
